import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SoundService } from '../../services/sound.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  user;
  expanded;
  
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private soundService: SoundService
  ) {
  }

  login() {
  }

  logout() {

  }

  open() {
    this.expanded = true;
  }

}



// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/components/header/header.component.ts